import { memo } from 'react';
import { EpStepContent, EpStepSelect } from '../../components';
import { useTranslation as t } from '../../../../hooks/useTranslation';
import { useTranslationStore } from '@/stores';

type QuestionsAnswersProps = {
  questionId: number;
  questionDescription: string;
  required: boolean;
  maxLength: number;
  questionReferLibraryId: number;
  questionTypeId: number;
  questionsLibrary: boolean;
  questionCategoryIncident: number;
  order: number;
  answerRequiredId: number | null;
  questionRequiredId: number | null;
  answers: {
    answerId: number;
    answerDescription: string;
  }[];
};

function EpQuestionSelect({
  QuestionsAnswers,
  index,
}: {
  QuestionsAnswers: QuestionsAnswersProps;
  index: number;
}) {
  const { translations } = useTranslationStore();
  return (
    <EpStepContent.Label label={`${QuestionsAnswers.questionDescription}  ${QuestionsAnswers.required ? '*' : ''}`}>
      <EpStepSelect
        description={QuestionsAnswers.questionDescription}
        customLabelValue={['answerDescription', 'answerId']}
        data={QuestionsAnswers.answers}
        errorMessage={t(translations['global'], '* Required Fied')}
        registerId={`questions.${index}`}
        required={QuestionsAnswers.required}
      />
    </EpStepContent.Label>
  );
}

export default memo(EpQuestionSelect);
